import { Fragment, useState } from 'react'
import classNames from 'classnames'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'
import { isTaskDone } from '../Task.utils'

import { TASK_TABLE_ROW_ACTIONS_CONFIG } from './TaskTableRow.constants'
import { renderTaskTableCell as defaultRenderTaskTableCell } from './TaskTableRow.utils'

import * as styles from './TaskTableRow.module.css'

function TaskTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  className = styles.TaskTableRow,
  columns,
  disabled,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isResizing,
  isSelected,
  isShort,
  item,
  renderCell = defaultRenderTaskTableCell,
  resizingColumn,
  scrollRef,
  showCellBorder,
  onChangeStatus,
  onChangeVisibility,
  onClickEmailTag,
  onClickFileTag,
  ...restProps
}) {
  const { id } = item

  const [isLoading, setLoading] = useState(false)

  const {
    handleCallAction,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, TASK_TABLE_ROW_ACTIONS_CONFIG)

  function handleChange(id, data, callback) {
    setLoading(true)

    return callback?.(id, data).finally(() => {
      setLoading(false)
    })
  }

  function handleChangeStatus(data) {
    return handleChange(id, data, onChangeStatus)
  }

  function handleChangeVisibility(data) {
    return handleChange(id, data, onChangeVisibility)
  }

  const moddedClassName = useTableRowModClassName({
    className: classNames(className, {
      [styles.done]: isTaskDone(item),
    }),
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={moddedClassName}
      key={id}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            disabled,
            isActive: column.name === resizingColumn,
            isLoading,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            width: column.width,
            onChangeStatus: handleChangeStatus,
            onChangeVisibility: handleChangeVisibility,
            onClickEmailTag: onClickEmailTag,
            onClickFileTag: onClickFileTag,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item).length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default TaskTableRow
